export default "__VITE_ASSET__8buD$Yis__"